(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legion-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  var last=0,on=false;
  function set(value){if(value!==on){on=value;document.body.classList.toggle('lg-scrolled',value);}}
  function check(){var y=window.scrollY||0;if(y<80){set(false);}else if(y>last+8&&y>220){set(true);}else if(y<last-40){set(false);}last=y;}
  window.addEventListener('scroll',check,{passive:true});
})();
(function(){
  var loading=false;
  function root(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';}
  function refresh(){
    if(loading)return;loading=true;
    fetch(root()+'?section_id=legion-cart-boost').then(function(r){return r.ok?r.text():'';}).then(function(html){
      if(!html)return;
      var fresh=new DOMParser().parseFromString(html,'text/html').querySelector('.lg-boost');
      if(!fresh)return;
      var page=document.querySelector('main .lg-boost');
      if(page)page.innerHTML=fresh.innerHTML;
      var footer=document.querySelector('cart-drawer .drawer__footer');
      if(footer){
        var old=footer.querySelector('.lg-boost');if(old)old.remove();
        if(fresh.querySelector('.lg-boost-item')){
          var copy=fresh.cloneNode(true);
          var bar=footer.querySelector('.lg-delivery-progress');
          if(bar&&bar.parentNode===footer){bar.insertAdjacentElement('afterend',copy);}else{footer.insertBefore(copy,footer.firstChild);}
        }
      }
    }).catch(function(){}).then(function(){loading=false;});
  }
  document.addEventListener('click',function(event){
    var button=event.target.closest('button.lg-boost-add');
    if(!button)return;
    event.preventDefault();
    button.disabled=true;
    var drawer=document.querySelector('cart-drawer');
    var inDrawer=drawer&&drawer.contains(button)&&typeof drawer.renderContents==='function'&&typeof drawer.getSectionsToRender==='function';
    var body={id:button.dataset.variant,quantity:1};
    if(inDrawer){body.sections=drawer.getSectionsToRender().map(function(s){return s.id;});body.sections_url=window.location.pathname;}
    var url=(window.routes&&window.routes.cart_add_url)||'/cart/add';
    fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:JSON.stringify(body)}).then(function(r){return r.json();}).then(function(data){
      if(data.status){button.disabled=false;return;}
      if(inDrawer){drawer.renderContents(data);refresh();}else{window.location.reload();}
    }).catch(function(){button.disabled=false;});
  });
  function start(){
    refresh();
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){subscribe(PUB_SUB_EVENTS.cartUpdate,function(){setTimeout(refresh,50);});}
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}else{start();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legion-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('toggle',function(event){const item=event.target;if(!item.matches('.lg-dropdown')||!item.open)return;const list=item.closest('.lg-menu-list');list.querySelectorAll(':scope > .lg-menu-item > .lg-dropdown[open]').forEach(function(other){if(other!==item)other.open=false;});},true);
document.addEventListener('keydown',function(event){if(event.key!=='Escape')return;document.querySelectorAll('.lg-header details[open]').forEach(function(item){item.open=false;item.querySelector('summary').focus();});});
document.addEventListener('click',function(event){if(event.target.closest('.lg-menu-item'))return;document.querySelectorAll('.lg-desktop-nav .lg-dropdown[open]').forEach(function(item){item.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legion-sticky-atc"]) return;
  try {
    
(function(){
  function init(){
    var bar=document.querySelector('[data-lg-sticky-atc]');
    if(!bar)return;
    var button=bar.querySelector('button');
    function mainButton(){return document.querySelector('product-info .product-form__submit');}
    var main=mainButton();
    if(!main||!button)return;
    function sync(){
      var current=mainButton();if(!current)return;
      var label=current.querySelector('span');
      var text=(label?label.textContent:current.textContent).trim();
      if(text)button.textContent=text;
      button.disabled=current.disabled||current.getAttribute('aria-disabled')==='true';
    }
    sync();
    new MutationObserver(sync).observe(main,{attributes:true,childList:true,subtree:true,characterData:true});
    button.addEventListener('click',function(){var current=mainButton();if(current)current.click();});
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        var entry=entries[0];
        var show=!entry.isIntersecting&&entry.boundingClientRect.top<0;
        bar.hidden=!show;
        document.body.classList.toggle('lg-sticky-atc-on',show);
        if(show)sync();
      }).observe(main);
    }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

  } catch(e) { console.error(e); }
})();
})();
